import React, { useRef, useState, useEffect } from 'react';
import styles from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';
import { LeftIcon, RightIcon } from '../icons';
import { useLang } from '@/i18n';

const UsedDuringDisasters = () => {
    const swiperRef = useRef<any>(null);
    const { t } = useLang('Delta3MaxSeriesStation.UsedDuringDisasters');
    const [slidesOffset, setSlidesOffset] = useState<any>(undefined);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const contentList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1757302925161/used-1-pc.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1757302925359/used-2-pc.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1757302925559/used-3-pc.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1757302925847/used-4-pc.jpg',
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setSlidesOffset(24);
            } else if (window.innerWidth < 1024) {
                setSlidesOffset(48);
            } else if (window.innerWidth < 1340) {
                setSlidesOffset(120);
            } else {
                const offset = (window.innerWidth - 1200) / 2;
                setSlidesOffset(offset);
            }
        }
    }, []);

    return (
        <section className={`${styles.UsedDuringDisasters} GtmModuleData-section`} data-section-id={'UsedDuringDisasters'}>
            <div className="title-box">
                <h5 className="title">{t('title')}</h5>
                <p className="subtitle">{t('subtitle')}</p>
            </div>
            <div className="content-list">
                <Swiper
                    modules={[Navigation]}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    spaceBetween={14}
                    slidesPerView={'auto'}
                    slidesOffsetBefore={slidesOffset}
                    slidesOffsetAfter={slidesOffset}
                    onSlideChange={(swiper) => {
                        setIsBeginning(swiper.isBeginning);

                        setIsEnd(swiper.isEnd);
                    }}
                    onReachEnd={() => setIsEnd(true)}
                    onFromEdge={() => setIsEnd(false)}
                >
                    {contentList.map((item, index) => (
                        <SwiperSlide key={index} className="power-swiper-slide">
                            <div className="card-item">
                                <div className="item-top">
                                    <EcoImg isOpenLazy className="power-swiper-img" pc={item.pc} />
                                </div>
                                <div className="item-desc-box">
                                    <div className="item-title">{item.title}</div>
                                    <div className="item-desc">{item.desc}</div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="swiper-btn-box">
                <span className={`btn-item ${isBeginning ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slidePrev()}>
                    <LeftIcon />
                </span>
                <span className={`btn-item ${isEnd ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slideNext()}>
                    <RightIcon />
                </span>
            </div>
        </section>
    );
};

export default UsedDuringDisasters;
